import React, { useState } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { changeDateFormate, datetimeToDate } from '../../../utils/dateFormat';
import { selectCurrentRole } from '../../../pages/login/authSlice';
import { useCreateRevGenCoachingGoalMutation, useRevgenGoalParentUpdateMutation } from './revGenSlice';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface NewRevGengoalProps {
    isNewGoal: (state: boolean) => void;
    authorId: string;
    authorName: string;
    employeeNumber: string;
    goalDate: Date | string;
    inputYear: number;
    inputMonth: number;
    goals: any;
    closeDialog: (res: boolean) => void;
}

export const NewRevGengoal = (props: NewRevGengoalProps) => {
    const [title, setTitle] = useState<string>('');
    const [goalDesc, setGoalDesc] = useState<string>('');
    const [CreateCoachingGoal] = useCreateRevGenCoachingGoalMutation();
    const [updateGoalParent] = useRevgenGoalParentUpdateMutation();
    let currentRole: string = useSelector(selectCurrentRole);
    currentRole = currentRole.charAt(0).toUpperCase() + currentRole.slice(1) || '';
    const now = new Date();

    const handleTextChange = (e: any, type: 'title' | 'goal') => {
        const eventVal = e.target.value;
        if (type === 'title') setTitle(eventVal);
        else if (type === 'goal') setGoalDesc(eventVal);
    };
    const handleCancel = () => {
        props.isNewGoal(false);
    };

    const handleSave = () => {
        if (title === '' || goalDesc === '') {
            toast.warn('Please fill the Title and Goal Description');
            return;
        }
        if (title.length > 50) {
            toast.warn('Title should not exceed 50 characters');
            return;
        }
        if (goalDesc.length < 10) {
            toast.warn('Sorry, but the Goal Description must be greater than 10 characters.');
            return;
        }
        const request = {
            authorId: props.authorId,
            employeeId: props.employeeNumber,
            month: props.inputMonth,
            year: props.inputYear,
            goalTitle: title,
            goalDate: datetimeToDate(props.goalDate),
            goalDescription: goalDesc,
        };

        CreateCoachingGoal(request)
        .unwrap()
        .then((res: any) => {
            if (res?.status) {
                if (res?.statusCode === 500) {
                    toast.error('Server Error');
                } else {
                    if (res?.message === 'Success') {
                        toast.success('Goal created successfully');
                    }
                    if (res?.message === 'Error') {
                        const data = res?.data;
                        if (data.item2) toast.warn(data.item2);
                        if (data.item3) toast.warn(data.item3);
                    }
                    props?.isNewGoal(false);
                    props?.closeDialog(false);
                    if (props.goals.length > 0) updateGoalParentFlag();
                }
            } else toast.error('Something went wrong');
        })
        .catch((error: any) => {
            toast.error(error);
        });
    };
    const updateGoalParentFlag = () => {
        const payload = {
            coachingGoalParentId: props?.goals[0]?.coaching_goal_parent_id,
            supervisorDiscussed: false,
            associateAcknowledged: false,
            monthEndReviewed: false,
        };
        updateGoalParent(payload)
        .unwrap()
        .then((data: any) => {
            console.log(data);
        })
        .catch((error: any) => {
            console.log(error);
        });
    };

    return (
        <>
            <h4 className="mt-2">New Goal</h4>
            <div className="logConversation p-2">
                <h6>Title</h6>
                <InputTextarea
                    className="borderRadius8 w-50"
                    onChange={(e: any) => handleTextChange(e, 'title')}
                    maxLength={50}
                    value={title}
                    rows={1}
                />
                <div className="d-flex justify-content-center textSmall lightText">{`${title.length}/50 character limit`}</div>
                <h5>Goal Description</h5>

                <div className="align-center d-flex justify-content-between mt-2">
                    <h6 className="color-purple">Goal Coaching</h6>
                    <hr className="color-purple width-75 border-2" />
                    <h6 className="color-purple">Beginning of the Month</h6>
                </div>
                <DescriptionBox
                    createdByLabel="Author"
                    createdByValue={`${props.authorId}, ${props.authorName}`}
                    value={goalDesc}
                    responseDescription={goalDesc}
                    limit={1000}
                    onChange={(value) => {
                        const syntheticEvent = {
                            target: { value },
                        };
                        handleTextChange(syntheticEvent, 'goal');
                    }}
                />

                <div className="d-flex justify-content-start mt-2">
                    <div className="me-3">
                        <h6>Date</h6>
                        <span>{changeDateFormate(datetimeToDate(now))}</span>
                    </div>
                    <div>
                        <h6>Role</h6>
                        <span>{currentRole}</span>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <Button
                        label="Cancel"
                        onClick={handleCancel}
                        className="btn-secondary me-2"
                    />
                    <Button label="Save" onClick={handleSave} className="btn-primary" />
                </div>
            </div>
        </>
    );
};
